import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { connect } from 'react-redux';
import Fa from 'react-fontawesome';
import { filter, each, sortBy } from 'lodash';
import NumberDisplay from '../../../../components/number-display';
import Counter from '../../../../components/counter';
import styles from './style.css';

// Import Selectors
import { getOutcome } from '../../PerformanceReducer';

function SalesRepStats(props) {
  const { stats } = props;
  if (stats.length === 0) {
    return null;
  }
  /*
  const qualified = sortBy(filter(stats, state => { return state.total >= 5; }), (stat) => {
    return stat.stages.won.amountPercentage;
  });
  */
  const active = filter(stats, (stat) => {
    const { owner } = stat;
    return owner && owner.is_active;
  });
  const qualified = sortBy(filter(active, stat => stat.total >= 3), stat => stat.stages.won.amountPercentage);
  let bestWinRate = 0;
  let worstWinRate = null;
  let totalWinRate = 0;
  each(qualified, (stat) => {
    bestWinRate = Math.max(bestWinRate, stat.stages.won.amountPercentage);
    totalWinRate += stat.stages.won.amountPercentage;
    if (worstWinRate === null) {
      worstWinRate = stat.stages.won.amountPercentage;
    } else {
      worstWinRate = Math.min(worstWinRate, stat.stages.won.amountPercentage);
    }
  });
  const averageWinRate = qualified.length > 0 ? totalWinRate / qualified.length : 0;
  let medianWinRate = 0;
  if (qualified.length) {
    medianWinRate = qualified[Math.floor(qualified.length / 2)].stages.won.amountPercentage;
  }
  const hints = {
    total: {
      title: 'Total Reps',
      text: 'Count of all sales representatives associated with a sales opportunity based on current opportunity filters.',
    },
    active: {
      title: 'Active Reps',
      text: 'Count of all sales representatives associated with a sales opportunity with an active CRM license based on current opportunity filters.',
    },
    median: {
      title: 'Median Win Rate',
      text: 'The win rate for the sales representative in the middle of all sales representatives included based on current opportunity filters.',
    },
    average: {
      title: 'Avg Win Rate',
      text: 'Average of individual sales representatives\' win rates included based on current opportunity filters.',
    },
    best: {
      title: 'Best Win Rate',
      text: 'The best individual win rate among all of sales representatives, with at least three closed opportunities, included in the current opportunity filters.',
    },
    worst: {
      title: 'Worst Win Rate',
      text: 'The worst individual win rate among sales representatives, with at least three closed opportunities, included in the current opportunity filters.',
    },
  };
  const popovers = {};
  each(hints, (hint, key) => {
    popovers[key] = (<Tooltip id={`popover-${key}`} title={hint.title}>{hint.text}</Tooltip>);
  });

  return (
    <div className={styles.stats}>
      <div className="row">
        <div className="col-xs-6 col-sm-4 col-md-2">
          <div className={`${styles.panelTotal} ${styles.panel} panel panel-default animated flipInY`}>
            <div className={`${styles.panelBody} panel-body`}>
              <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={popovers.total}>
                <i className={`${styles.tipTrigger} animated fadeIn`}><Fa name="ellipsis-h" /></i>
              </OverlayTrigger>
              <h3 className={styles.statHeading}>Total Reps</h3>
              <div className={styles.counter}>
                <Counter value={stats.length}>
                  <NumberDisplay value={stats.length} precision={0} />
                </Counter>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xs-6 col-sm-4 col-md-2">
          <div className={`${styles.panelQualified} ${styles.panel} panel panel-default animated flipInY`}>
            <div className={`${styles.panelBody} panel-body`}>
              <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={popovers.active}>
                <i className={`${styles.tipTrigger} animated fadeIn`}><Fa name="ellipsis-h" /></i>
              </OverlayTrigger>
              <h3 className={styles.statHeading}>Active Reps</h3>
              <div className={styles.counter}>
                <Counter value={active.length}>
                  <NumberDisplay value={active.length} precision={0} />
                </Counter>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xs-6 col-sm-4 col-md-2">
          <div className={`${styles.panelMedian} ${styles.panel} panel panel-default animated flipInY`}>
            <div className={`${styles.panelBody} panel-body`}>
              <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={popovers.median}>
                <i className={`${styles.tipTrigger} animated fadeIn`}><Fa name="ellipsis-h" /></i>
              </OverlayTrigger>
              <h3 className={styles.statHeading}>Median&nbsp;Win&nbsp;Rate</h3>
              <div className={styles.counter}>
                <Counter value={medianWinRate}>
                  <NumberDisplay value={medianWinRate} suffix="%" />
                </Counter>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xs-6 col-sm-4 col-md-2">
          <div className={`${styles.panelAverage} ${styles.panel} panel panel-default animated flipInY`}>
            <div className={`${styles.panelBody} panel-body`}>
              <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={popovers.average}>
                <i className={`${styles.tipTrigger} animated fadeIn`}><Fa name="ellipsis-h" /></i>
              </OverlayTrigger>
              <h3 className={styles.statHeading}>AVG Win Rate</h3>
              <div className={styles.counter}>
                <Counter value={averageWinRate}>
                  <NumberDisplay value={averageWinRate} suffix="%" />
                </Counter>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xs-6 col-sm-4 col-md-2">
          <div className={`${styles.panelBestWinRate} ${styles.panel} panel panel-default animated flipInY`}>
            <div className={`${styles.panelBody} panel-body`}>
              <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={popovers.best}>
                <i className={`${styles.tipTrigger} animated fadeIn`}><Fa name="ellipsis-h" /></i>
              </OverlayTrigger>
              <h3 className={styles.statHeading}>Best Win Rate</h3>
              <div className={styles.counter}>
                <Counter value={bestWinRate}>
                  <NumberDisplay value={bestWinRate} suffix="%" />
                </Counter>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xs-6 col-sm-4 col-md-2">
          <div className={`${styles.panelWorstWinRate} ${styles.panel} panel panel-default animated flipInY`}>
            <div className={`${styles.panelBody} panel-body`}>
              <OverlayTrigger trigger={['hover', 'focus']} placement="left" overlay={popovers.worst}>
                <i className={`${styles.tipTrigger} animated fadeIn`}><Fa name="ellipsis-h" /></i>
              </OverlayTrigger>
              <h3 className={styles.statHeading}>Worst Win Rate</h3>
              <div className={styles.counter}>
                <Counter value={worstWinRate}>
                  <NumberDisplay value={worstWinRate} suffix="%" />
                </Counter>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    stats: getOutcome(state),
  };
}

SalesRepStats.propTypes = {
  stats: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default connect(mapStateToProps)(SalesRepStats);
